import React from 'react'

const ErrorCodeTab = (props) => {

  const style = {
    main:{
      display: "flex",
      flexDirection:"row",
      alignItems:"center",
      height:"80px"
    },
    box:{
      display: "flex",
      color:"#DFDFDF"
    },
    order:{
      padding: "5px 10px",
      fontSize: "16px",
      fontWeight: "400",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width:"41px"
    },
    content:{
      display:"flex",
      flexDirection:"column",
      justifyContent:"center",
      alignItems:"flex-start",
      marginLeft:"5px",
      marginRight:"5px",
      padding:"20px 10px",
    },
    tabName:{
      alignItems:"center",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "20px",
      display:"flex",
      marginBottom:"5px"
    },
    desc:{
      display:"flex",
      fontSize:"13px",
      fontWeight:"400",
      lineHeight:"20px",
      alignItems:"center",
      textAlign:"left"
    }

  }
  return (
    <div
        style={style.main}
      >
        <div style={style.box}>
          <span
            style={style.order}
          >
           {props.orderNumber}
          </span>
          <div style={style.content}>
            <div
              style={style.tabName}
            >
            {props.tabName}
            </div>
            <div style={style.desc}>
              {props.errorDesc}
            </div>
          </div>
          
        </div>
      </div>
  )
}

export default ErrorCodeTab;